<template>
  <el-dialog
    title=""
    :visible.sync="dialogMsg.dialogScholar"
    width="30%"
    :before-close="handleClose"
  >
    <el-row :gutter="20">
      <el-col :span="6">
        <h4>学者</h4>
      </el-col>
      <el-col :span="12">
        <el-autocomplete
          v-model="selectAuthor"
          :fetch-suggestions="querySearchAsync"
          @select="handleSelect"
          placeholder="选择学者"
        >
        </el-autocomplete>
      </el-col>
    </el-row>
    <el-row v-if="selectItem" :gutter="20">
      <el-col :span="6"> </el-col>
      <el-col :span="12">
        <div class="dia-sch-img">
          <img :src="selectItem ? selectItem.image : null" />
        </div>
        <div class="dia-sch-name">
          <h4>{{ selectItem ? selectItem.name : null }}</h4>
          <h5>{{ selectItem ? selectItem.englishName : null }}</h5>
        </div>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="addScholarBack">取 消</el-button>
      <el-button type="primary" @click="addScholarOK">添 加</el-button>
      <!-- <el-button type="primary" @click="addScholarOK">修 改</el-button> -->
    </span>
  </el-dialog>
</template>
<script>
import { getPersons } from "../../bestPractice/bestPracticeList.gql";
export default {
  props: { dialogMsg: Object, dialogItem: Object },
  data() {
    return {
      addMsg: {},
      scholarData: [],
      selectAuthor: "",
      selectItem: null,
    };
  },
  watch: {
    dialogItem(val, oldVal) {
      this.addMsg = JSON.parse(JSON.stringify(val));
      this.selectAuthor = JSON.parse(JSON.stringify(val.name));
    },
  },
  methods: {
    handleSelect(item) {
      console.log(item);
      this.addMsg.personId = item.id;
      this.selectItem = item;
    },
    querySearchAsync(queryString, callback) {
      this.$global
        .GraphqlQuery(this, getPersons, {
          status: -1,
          take: 0,
          order: "+englishName",
          englishName: this.selectAuthor,
        })
        .then((res) => {
          for (let i of res.data) {
            i.value = i.name; //将想要展示的数据作为value
          }
          this.scholarData = res.data;
          callback(this.scholarData);
        });
    },
    getPersons() {
      this.$global
        .GraphqlQuery(this, getPersons, {
          status: -1,
          take: 0,
          order: "+englishName",
        })
        .then((res) => {
          this.scholarData = res.data;
        });
    },
    // 测试
    handleClose() {
      this.$emit("addScholarBack", false);
    },
    addScholarBack() {
      this.$emit("addScholarBack", false);
      this.addMsg = {};
    },
    addScholarOK() {
      this.$emit("addScholarOK", this.addMsg);
      this.addMsg = {};
    },
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  display: flex;
  justify-content: center;
  .el-col-6 {
    display: flex;
    h4 {
      width: 40px;
      align-self: center;
      font-size: 16px;
      font-weight: normal;
      color: $keywords;
      margin-right: 40px;
    }
  }
  .el-col-12 {
    .dia-sch-img {
      margin-top: 20px;
      img {
        width: 60px;
        height: 60px;
        border-radius: 30px;
      }
      display: inline-block;
    }
    .dia-sch-name {
      margin-top: 30px;
      margin-left: 10px;
      vertical-align: top;
      display: inline-block;
    }
  }
}
.el-dialog__footer {
  padding: 10px 25% 20px;
  .dialog-footer {
    height: 28px;
    display: flex;
    justify-content: center;
    .el-button--default:hover {
      background: $base-color;
      color: $blueBtna;
    }
    .el-button--default {
      border-radius: 100px;
      border: 1px solid $schoolTagBorder;
      padding: 4px 24px;
      span {
        font-size: 12px;
        color: $schoolTagColor;
      }
    }
    .el-button--primary {
      border-radius: 100px;
      background: $pageViewSmall;
      border: 1px solid $pageViewSmall;
      padding: 4px 24px;
      span {
        font-size: 12px;
        color: $base-color;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exploration/components/DialogScholar.vue